import React, { Component } from "react";
import classes from "./Offers.module.css";
import Checkbox from "../../../components/Checkbox/Checkbox";
import Face from "../../../components/Face/Face";
import Loader from "../../../components/Loader/Loader";
import { NavLink } from "react-router-dom";
import { connect } from "react-redux";
import {
  calculateTotalMoney,
  resetTotalMoney,
  calculateTotalTime,
  resetTotalTime,
  changeChoosenItems,
  changeMaster,
  setTotalMasterList,
  setModalWindow,
  phonesSetTotal,
} from "../../../store/actions/actions";

import axios from "axios";
import List from "../List/List";

import { API_URL } from "../../../utils/api";
import { database } from "../../../firebase/db";

class Offers extends Component {
  state = {
    choosenItemsForDisplay: [],
  };

  // Функция подписки на изменения базы данных masters.json и phones.json
  // После обновления их кем-то из пользователей получаем уведомление с помощью Firebase
  // И перезаписываем изменения себе
  firebaseObserver = () => {
    const phonesJson = database.ref("phones/");
    const mastersJson = database.ref("masters/");

    phonesJson.on("child_added", (snapshot) => {
      const data = snapshot.val();

      //записываем данные в Редакс
      this.props.phonesSetTotal(data);
    });

    mastersJson.on("child_added", (snapshot) => {
      const data = snapshot.val();

      const newMasterJson = this.props.masterList.map((master, index) => {
        return [
          master[0],
          master[1],
          master[2],
          { ...master[3], ...data[index][3] },
        ];
      });

      this.props.setTotalMasterList(newMasterJson);
    });
  };

  async componentDidMount() {
    this.firebaseObserver();

    this.props.setModalWindow(false);

    //получаем данные из БД
    try {
      const response = await axios.get(`${API_URL}/masters.json`);

      const data =
        response.data[
          Object.keys(response.data)[Object.keys(response.data).length - 1]
        ];

      //записываем данные в Редакс
      this.props.setTotalMasterList(data);

      //удаляем лишние записи
      for (let i = 0; i < Object.keys(response.data).length - 1; i++) {
        await axios.delete(
          `${API_URL}/masters/${Object.keys(response.data)[i]}.json`
        );
      }
    } catch (error) {
      console.log(error);
    }
  }

  //обработчик чек-боксов
  handleChange(e) {
    const item = e.target.value || e.target.name;
    const isChecked = e.target.checked;

    if (isChecked) {
      const state = { ...this.props };
      state.choosenItems.add(item);
      this.props.changeChoosenItems(state.choosenItems);
    }

    if (!isChecked) {
      const state = { ...this.props };
      state.choosenItems.delete(item);
      this.props.changeChoosenItems(state.choosenItems);
    }

    this.calculateMoneyHandler();
    this.calculateTimeHandler();

    // создаем массив выбранных чек-боксов для отображения
    const resultArr = [];

    this.props.choosenItems.forEach((item) => {
      resultArr.push(item.split(",")[0]);
    });

    this.setState({
      choosenItemsForDisplay: resultArr,
    });
  }

  //считаем деньги
  calculateMoneyHandler = () => {
    let sumMoney = 0;
    for (let value of this.props.choosenItems) {
      const money = value.split(",");
      sumMoney += +money[2];
    }

    this.props.calculateTotalMoney(sumMoney);
  };

  //считаем время
  calculateTimeHandler = () => {
    let sumTime = 0;
    for (let value of this.props.choosenItems) {
      const time = value.split(",");
      sumTime += +time[1];
    }

    this.props.calculateTotalTime(sumTime);
  };

  //выбираем мастера
  masterChangeHandler = (num) => {
    // если мастер не меняется пропускаем
    if (this.props.master === num) {
      return;
    }

    // если меняется мастер, но услуги не выбранно - просто меняем мастера
    if (this.state.choosenItemsForDisplay.length === 0) {
      this.props.resetTotalMoney();
      this.props.resetTotalTime();
      this.props.changeMaster(num);
      this.props.changeChoosenItems(new Set());

      //сбрасываем дефолтные чек-боксы при смене мастера
      document.querySelectorAll("input").forEach((item) => {
        item.checked = false;
      });

      // сбрасываем массив выбранных услуг
      this.setState({
        choosenItemsForDisplay: [],
      });
    } else {
      // если меняется мастер и услуги выбранно - задаем вопрос
      let quest = window.confirm(
        "Attenzione! È necessario prenotare il tuo servizio con un barber alla volta"
      );

      if (quest) {
        this.props.resetTotalMoney();
        this.props.resetTotalTime();
        this.props.changeMaster(num);
        this.props.changeChoosenItems(new Set());

        //сбрасываем дефолтные чек-боксы при смене мастера
        document.querySelectorAll("input").forEach((item) => {
          item.checked = false;
        });

        // сбрасываем массив выбранных услуг
        this.setState({
          choosenItemsForDisplay: [],
        });
      }
    }
  };

  render() {
    return (
      <>
        {this.props.masterList.length === 0 ? (
          <Loader />
        ) : (
          <div className={classes.Offers}>
            <div className={classes.Offers_number}>
              <div className={classes.Offers_number_yellow}>
                <p>1</p>
              </div>
              <div className={classes.Offers_number_white}>
                <p>
                  <span>passo </span>
                  Scegli barbiere
                </p>
              </div>
            </div>
            <div className={classes.Offers_masters}>
              {this.props.masterList.map((master, index) => {
                return (
                  <Face
                    key={index}
                    face={master[1]}
                    name={master[0]}
                    number={index}
                    masterChangeHandler={this.masterChangeHandler}
                    active={this.props.master}
                  />
                );
              })}
            </div>

            <div className={classes.Offers_table}>
              {this.props.masterList[this.props.master][2].map(
                (offer, index) => {
                  return (
                    <div key={index}>
                      <Checkbox
                        master={this.props.master}
                        onChange={(e) => this.handleChange(e)}
                        offer={offer}
                        name={offer}
                      />
                    </div>
                  );
                }
              )}
            </div>
            <p className={classes.Offers_table_text}>** A partire da</p>
            <List choosenItems={this.state.choosenItemsForDisplay} />
            {this.props.totalMoney > 0 && this.props.totalTime > 0 ? (
              <NavLink className={classes.Offers_next} to="/dates">
                AVANTI
              </NavLink>
            ) : (
              <p className={classes.Offers_next_disabled}>AVANTI</p>
            )}
          </div>
        )}
      </>
    );
  }
}

function mapStateToProps(state) {
  return {
    masterList: state.masterList,
    totalMoney: state.totalMoney,
    totalTime: state.totalTime,
    choosenItems: state.choosenItems,
    master: state.master,
    defaultMasterList: state.defaultMasterList,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    setTotalMasterList: (arr) => dispatch(setTotalMasterList(arr)),
    calculateTotalMoney: (num) => dispatch(calculateTotalMoney(num)),
    calculateTotalTime: (num) => dispatch(calculateTotalTime(num)),
    resetTotalMoney: () => dispatch(resetTotalMoney()),
    resetTotalTime: () => dispatch(resetTotalTime()),
    changeChoosenItems: (item) => dispatch(changeChoosenItems(item)),
    changeMaster: (num) => dispatch(changeMaster(num)),
    setModalWindow: (bool) => dispatch(setModalWindow(bool)),
    phonesSetTotal: (phones) => dispatch(phonesSetTotal(phones)),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Offers);
